export default "__VITE_ASSET__305b640f__"